// Module
var code = `<div class="informer-panel">
    <div class="informer-panel-container-top">
        <terceraButton name="add" SVG="true" terceraButtonStyle="image-button-plain" text="" enabled="true" on-btnClick="onAdd" visible="{{.showHide}}" tooltip="{{addInsBtnTooltip}}"/>
        <watchlistComboBox name="wlComboBox" items="{{.items}}" storageName="watchlistSheets" tooltip="{{editableCBtooltip}}" />
    </div>

    <div class="informer-panel-container-table">
        <terceraPanel name='windowPanelBodyQT' />
    </div>
</div>`;
// Exports
export default code;